import React, { FC } from "react";
import { Col, Row } from "react-bootstrap";
import Link from "../../common/Link";
import { NavbarItem } from "../Navbar";

const DesktopNavbar: FC<{
    navLinkClickHandler: (linkId: string, elementId: string) => void,
    navbar: NavbarItem[]
}> = ({ navLinkClickHandler, navbar }) => {
    return <ul className="navbar-nav me-auto mb-2 d-none d-lg-flex mb-lg-0" id="navbarSupportedContent">
        {
            navbar.map((item: NavbarItem, index: number) => {
                let href = typeof item.path !== 'undefined' ? item.path : undefined;
                return item.headerNavbar ? (
                    <li
                        id={`navbar-${item.id}`}
                        key={index}
                        className={'nav-item' + (item.subRoutes?.length ? ' dropdown' : '')}
                    >
                        {item.subRoutes?.length ? (
                            <>
                                <Link
                                    id={`navbar- + ${item.id}`}
                                    className="nav-link dropdown-toggle"
                                    href={href}
                                    title={item.name}
                                    isDropdown
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    onClick={() => navLinkClickHandler('navbar-search-link', 'navbar-search')}
                                >
                                    {item.name}
                                </Link>
                                <ul
                                    id={`navbar-${item.id}-dropdown-menu`}
                                    className="dropdown-menu"
                                    aria-labelledby={'navbar-' + item.id}
                                >
                                    <li
                                        id={`navbar-${item.id}-${index}`}
                                        className={'nav-item px-3' + (item.subRoutes?.length ? ' dropdown' : '')}
                                    >
                                        <Row>
                                            {item.subRoutes.map((item2: NavbarItem, index2: number) => {
                                                let href2 = typeof item2.path !== 'undefined' ? (item.path ?? '') + item2.path : undefined;
                                                return item2.headerNavbar ? <Col key={index2}>
                                                    {
                                                        !item2.path || !href2 ? <span
                                                            className="nav-link"
                                                            title={item2.name}
                                                        >
                                                            {item2.name}
                                                        </span> : <Link
                                                            className="nav-link"
                                                            href={href2}
                                                            title={item2.name}
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`.navbar-collapse-mobile, #navbar-${item2.id}-dropdown-menu, #navbar-${item.id}-dropdown-menu`}
                                                        >
                                                            {item2.name}
                                                        </Link>
                                                    }
                                                    {
                                                        item2.subRoutes && item2.subRoutes.length ? (
                                                            <ul id={`navbar-${item2.id}-dropdown-items`}>
                                                                {
                                                                    item2.subRoutes.map((item3: NavbarItem, index3: number) => {
                                                                        let href3 = typeof item3.path !== 'undefined'
                                                                            ? (item.path ?? '') + (item2.path ?? '') + item3.path
                                                                            : undefined;
                                                                        return item3.headerNavbar ? <li key={index3}>
                                                                            {
                                                                                !item3.path || !href3 ? <span
                                                                                    className="nav-link"
                                                                                    title={item3.name}
                                                                                >
                                                                                    {item3.name}
                                                                                </span> : <Link
                                                                                    className="nav-link"
                                                                                    href={href3}
                                                                                    title={item3.name}
                                                                                    data-bs-toggle="collapse"
                                                                                    data-bs-target={`.navbar-collapse-mobile, #navbar-${item2.id}-dropdown-menu`}
                                                                                    onClick={() => navLinkClickHandler('navbar-search-link', 'navbar-search')}
                                                                                >
                                                                                    {item3.name}
                                                                                </Link>
                                                                            }
                                                                        </li> : <React.Fragment key={index3}></React.Fragment>
                                                                    })}
                                                            </ul>
                                                        ) : <React.Fragment />
                                                    }
                                                </Col> : <React.Fragment key={index2}></React.Fragment>
                                            }
                                            )}
                                        </Row>
                                    </li>
                                </ul>
                            </>
                        ) : (
                            <React.Fragment key={index}>
                                {!item.path ? <span
                                    className="nav-link"
                                    title={item.name}
                                >
                                    {item.name}
                                </span> : <Link
                                    className="nav-link"
                                    href={item.path ? item.path : undefined}
                                    data-bs-toggle="collapse"
                                    data-bs-target=".navbar-collapse-mobile"
                                    onClick={() => navLinkClickHandler('navbar-search-link', 'navbar-search')}
                                >
                                    {item.name}
                                </Link>}
                            </React.Fragment>
                        )}
                    </li>
                ) : <React.Fragment key={index}></React.Fragment>
            })}
    </ul>
}

export default DesktopNavbar;